export interface FormatPowerParams {
  h?: boolean
  absolute?: boolean
}

export const formatPower = (power: number, args: FormatPowerParams = {}) => {
  const { h = false, absolute = false } = args
  if (Math.abs(power) >= 1000) {
    if (absolute) {
      return `${Math.abs(power / 1000).toFixed(2)} kW${h ? 'h' : ''}`
    }
    return `${(power / 1000).toFixed(2)} kW${h ? 'h' : ''}`
  }
  return `${Math.round((Math.abs(power) + Number.EPSILON) * 100) / 100} W${
    h ? 'h' : ''
  }`
}

export const formatEventMessage = (message: string) => {
  switch (message) {
    case 'TopConsumersDay':
      return 'Top Consumers for the Day'
    case 'TopConsumersWeek':
      return 'Top Consumers for the Week'
    case 'TotalConsumptionDay':
      return 'Total Consumption for the Day'
    case 'TotalConsumptionWeek':
      return 'Total Consumption for the Week'
    case 'TopConsumersSoFar':
      return 'Top Consumers so far'
    default:
      return message.split(/(?=[A-Z])/).join(' ')
  }
}
